"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var FooterNavigation_1 = require("../FooterNavigation");

var Accordion_1 = require("./Accordion");

var AccordionGroupStateful_1 = require("./AccordionGroupStateful");
/** See Accordion Example for usage */


var AccordionGroup =
/** @class */
function (_super) {
  __extends(AccordionGroup, _super);

  function AccordionGroup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.accordionButtonElms = [];
    _this.uuid = _this.props.id || uniqid_1["default"]("lsg--" + _this.constructor.name.toLowerCase());

    _this.registerAccordionButtonElm = function (index) {
      return function (elm) {
        // Registers a new elements, but also deletes elements that are no longer there
        return _this.accordionButtonElms = elm ? __spreadArrays(_this.accordionButtonElms.slice(0, index), [elm], _this.accordionButtonElms.slice(index)) : _this.accordionButtonElms.slice(index, 1);
      };
    };

    _this.keyHandler = function (e) {
      var _a;

      utils_1.SelectionNavHelper.useKeyMap(e, (_a = {}, _a[w3c_keys_1.Key.Home] = function (elms) {
        return elms.first().focus();
      }, _a[w3c_keys_1.Key.End] = function (elms) {
        return elms.last().focus();
      }, _a[w3c_keys_1.Key.ArrowDown] = function (elms) {
        return elms.next().focus();
      }, _a[w3c_keys_1.Key.ArrowUp] = function (elms) {
        return elms.prev().focus();
      }, _a), utils_1.SelectionNavHelper.getFocusHandler(_this.accordionButtonElms, document.activeElement));
    };

    _this.setOpenIndex = function (index) {
      return function (_open, _id, ev) {
        // elaborate checking because of typescript props interface definintion
        if (!(_this.props.multiple === true)) {
          _this.props.onChange(_this.props.openIndex !== index ? index : -1, _this.uuid, ev);
        }
      };
    };

    return _this;
  }

  AccordionGroup.prototype.render = function () {
    var _this = this;

    var accordionClassNames = utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "accordion", this.props.className]);
    return React.createElement("dl", {
      role: "presentation",
      className: accordionClassNames,
      id: this.props.id
    }, React.Children.map(this.props.children, function (child, i) {
      var additionalProps = {
        onKeyDown: _this.keyHandler,
        refCallback: _this.registerAccordionButtonElm(i),
        asDescriptionItems: true
      };

      if (!(_this.props.multiple === true)) {
        additionalProps.isOpen = _this.props.openIndex === i;
        additionalProps.onChange = _this.setOpenIndex(i);
      }

      return child.type === Accordion_1.Accordion || child.type === FooterNavigation_1.FooterNavigation.Block ? React.cloneElement(child, additionalProps) : child;
    }));
  };

  AccordionGroup.Stateful = AccordionGroupStateful_1.AccordionGroupStateful;
  return AccordionGroup;
}(React.Component);

exports.AccordionGroup = AccordionGroup;